export default "__VITE_PUBLIC_ASSET__2b861325__"